var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "faqq" }, [
    _c("section", { staticClass: "faqq__sidebar" }, [_c("faq-sidebar")], 1),
    _vm._v(" "),
    _c(
      "section",
      { staticClass: "faqq__main" },
      _vm._l(_vm.categories, function (category) {
        return _c("faq-category", {
          key: category.term_id,
          attrs: {
            category: category,
            active: category.term_id === _vm.activeCategory,
            questions: _vm.questionsByCategory(category.term_id),
          },
        })
      }),
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/Faq.vue